import { QrCodeIcon } from "@heroicons/react/24/solid";

const ProducerCodeTitleHeader = () => {
  return (
    <>
      <div className="flex gap-2 items-center">
        <div>
          <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
        </div>
        <div className="flex flex-col leading tight">
          <h3 className="text-xs font-medium text-gray-500">
            Producer Code Module
          </h3>
          <h1 className="mr-auto font-bold text-primary text-md uppercase">
            All Carrier Producer Codes
          </h1>
        </div>
      </div>
    </>
  );
};

export default ProducerCodeTitleHeader;
